var alignment_rtlignore_default = {
  "alignLeft": "fW6AZ",
  "textWrapNowrap": "FcZ7h",
  "alignRight": "GPMEO",
  "alignCenter": "cQmyd",
  "sizeFullWidth": "MxU7s",
  "renderedInTable": "GrFOs",
  "sizeOriginal": "_8mWL2",
  "sizeContent": "dlbwe",
  "sizeSmall": "ChT5y",
  "sizeSmallCenter": "T4kgW",
  "flex": "_37M-c",
  "LEFT": "XnhWf",
  "CENTER": "_9sflC",
  "RIGHT": "rBBiU",
  "AUTO": "XzfVg",
  "JUSTIFY": "FZzqa"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
